import { gql } from '@apollo/client';
import { client } from 'graphql/client';

export const NEW_PRICING_SCHEME = gql`
  mutation NewPricingSchemeByClientId($input: PricingSchemeInput!) {
    newPricingSchemeByClientId(input: $input) {
      success
      message
      data
      messageKey
    }
  }
`;

export interface NewPricingSchemeResponse {
  newPricingSchemeByClientId: { success: boolean; message: string; data?: string | null; messageKey?: string | null };
}

export interface PricingSchemeInputData {
  clientId: number;
  pricingSchemeId?: number | null;
  pricingSchemeName: string;
  pricingSchemeDescription?: string | null;
  businessScenario: number;
  priceConfig: Array<{
    pricingFeeItemCode: number;
    factorsType?: string | null;
    allPriceConfig: Array<{
      primaryFactorConfig?: string | null;
      groupId: number;
      contentPriceConfig: string; // JSON string per backend schema
    }>;
  }>;
}

export const submitNewPricingScheme = async (input: PricingSchemeInputData) => {
  const { data, errors } = await client.mutate<NewPricingSchemeResponse, { input: PricingSchemeInputData}>({
    mutation: NEW_PRICING_SCHEME,
    variables: { input }
  });
  if (errors && errors.length) throw errors[0];
  return data!.newPricingSchemeByClientId;
};


